/**
 * MaterialHelpers - commonly needed three.js material presets for Genesys scenes.
 */

import * as THREE from 'three';
export class MaterialHelpers {


  static createInvisibleMaterial(): THREE.MeshBasicMaterial {
    return new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 0.0
    });
  }

  /** Creates a wireframe material with the given color.
   *
   * @param color - The color of the material
   * @returns A new THREE.MeshBasicMaterial
   */
  static createWireframeMaterial(color: number): THREE.MeshBasicMaterial {
    return new THREE.MeshBasicMaterial({
      color: color,
      transparent: true,
      opacity: 0.5,
      wireframe: true
    });
  }
}